import {
  useSortable,
  SortableContext,
  horizontalListSortingStrategy,
  verticalListSortingStrategy
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { useLevelPlaySurface } from '@/shared/level-play'

import { LevelPlayAtThePlaceWord } from './Word'

export const LevelPlayAtThePlaceBoard = ({
  id,
  items
}) => {
  const { isSubmitting, answerIsRight, answerIsWrong, disableInputs } =
    useLevelPlaySurface()
  const {
    active,
    attributes,
    isDragging,
    listeners,
    over,
    setNodeRef,
    transition,
    transform
  } = useSortable({
    id,
    data: {
      type: 'container',
      children: items
    }
  })
  const isOverContainer = over
    ? (id === over.id && active?.data.current?.type !== 'container') ||
      items.includes(over.id)
    : false

  return (
    <SortableContext
      id={id}
      items={items}
      strategy={horizontalListSortingStrategy}
      disabled={disableInputs}
    >
      <div
        id={id}
        ref={setNodeRef}
        //   transition,
        //   transform: CSS.Translate.toString(transform),
        //   opacity: isDragging ? 0.5 : undefined
        className={`w-full min-h-[150px] flex flex-row flex-wrap items-start content-start gap-3 md:gap-3 p-3 lg:p-4  ${
          isOverContainer ? 'bg-gray-300' : 'bg-gray-200'
        } `}
      >
        {items.map(id => (
          <LevelPlayAtThePlaceWord
            key={id}
            id={id}
            text={id}
          />
        ))}
        {id && items && items.length == 0 && (
          <span className="text-gray-600 text-base font-medium block w-full text-center my-auto">
            Arraste as expressões corretas para cá{' '}
          </span>
        )}
      </div>
    </SortableContext>
  )
}
